import { MenuButton } from '@frameio/vapor';
import { IconLogout } from '@frameio/vapor-icons';
import TEXT from './generated/TEXT/LogoutNavItem';

TEXT.DEFINE({
  /** Menu item label that logs the user out from the account avatar menu */
  logout: 'Log out',
});

export function LogoutNavItem() {
  return (
    <MenuButton
      as="a"
      data-testid="primary-nav--log-out-button"
      href="/logout"
      iconBefore={<IconLogout />}
      isLink={true}
      variant="destructive"
    >
      {TEXT.logout}
    </MenuButton>
  );
}
